import './styles.scoped.css'
import {useEffect} from 'react'
import {Typography, Button, Modal, TextField} from '@mui/material'
import {useGlobalStates} from '../../../../contexts/GlobalStatesContext'
import {accountApi} from '../../../../services'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {parseError} from '../../../../utils/helpers'

export default ({open, setOpen, data, loadData}) => {
    const {setLoading, setMessageBox} = useGlobalStates()
    const form = useForm({
        resolver: yupResolver(
            yup.object().shape({
                reason: yup.string().required('Reason is required'),
            }),
        ),
    })

    useEffect(() => {
        form.reset()
    }, [open])

    const handleOk = reason => {
        setLoading(true)
        accountApi
            .reactivateUser(data?.id, reason)
            .then(() => {
                setLoading(false)
                setOpen(false)
                setMessageBox({
                    status: 'success',
                    title: 'Admin Reactivated',
                    description: 'The team member now has full access to the platform with their previous permissions restored.',
                })
                loadData()
            })
            .catch(error => {
                setLoading(false)
                setOpen(false)
                const {title, description} = parseError(error)
                if (description) {
                    setMessageBox({status: 'error', title, description})
                }
            })
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    <div className="title">
                        <Typography variant="h6" color="text.primary">
                            {`Reactivate ${data?.first_name}'s Account?`}
                        </Typography>
                    </div>
                    <br />
                    <Typography variant="body2" color="text.primary" style={{textAlign: 'center'}}>
                        Reactivating will restore Allissa’s access, permissions, and notifications. Review role and security settings before
                        confirming.
                    </Typography>
                    <br />
                    <Typography variant="inputLabel" color="text.secondary">
                        Reason{' '}
                        <Typography variant="inputLabel" color="error">
                            *
                        </Typography>
                    </Typography>
                    <TextField
                        placeholder="Please tell us the reason..."
                        fullWidth
                        multiline
                        rows={5}
                        {...form.register('reason')}
                        error={!!form.formState.errors['reason']}
                        helperText={form.formState.errors['reason']?.message}
                    />
                    <br />
                    <br />
                    <div className="actions">
                        <Button variant="outlined" fullWidth onClick={() => setOpen(false)}>
                            Cancel
                        </Button>
                        <Button variant="contained" fullWidth onClick={form.handleSubmit(handleOk)}>
                            Reactivate Account
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
